import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Alert
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

const StripeConnectRefresh: React.FC = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/dashboard/settings');
  };

  const handleGoBack = () => {
    navigate('/dashboard');
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      p: 3
    }}>
      <Card sx={{ maxWidth: 500, width: '100%' }}>
        <CardContent sx={{ textAlign: 'center', p: 4 }}>
          <RefreshIcon sx={{ fontSize: 80, color: '#ff9800', mb: 2 }} />
          <Typography variant="h4" sx={{ color: '#ff9800', mb: 2 }}>
            Session expirée
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
            Votre session d'activation des paiements a expiré. 
            Vous pouvez réessayer l'activation depuis vos paramètres.
          </Typography>
          
          <Alert severity="info" sx={{ mb: 3 }}>
            L'activation des paiements prend généralement moins de 5 minutes.
          </Alert>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              onClick={handleRetry}
              startIcon={<RefreshIcon />}
              sx={{
                backgroundColor: '#C9B6AB',
                '&:hover': {
                  backgroundColor: '#C1A08E',
                },
              }}
            >
              Réessayer l'activation
            </Button>
            <Button
              variant="outlined"
              onClick={handleGoBack}
              startIcon={<ArrowBackIcon />}
              sx={{
                borderColor: '#C9B6AB',
                color: '#C9B6AB',
                '&:hover': {
                  borderColor: '#C1A08E',
                  backgroundColor: 'rgba(201, 182, 171, 0.1)',
                  color: '#C1A08E',
                },
              }}
            >
              Retour au tableau de bord
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default StripeConnectRefresh;
